import React from 'react';
import { cn } from '../lib/utils';

interface BrandMarkProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** Lighter mark for dark brand panels */
  inverted?: boolean;
}

const sizeMap = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-14 w-14',
} as const;

const iconSizeMap = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-7 w-7',
} as const;

/** Unibyte mark — geometric “U” monogram */
export const BrandMark: React.FC<BrandMarkProps> = ({
  size = 'md',
  className,
  inverted = false,
}) => (
  <div
    className={cn(
      'flex items-center justify-center rounded-xl shadow-soft',
      sizeMap[size],
      inverted
        ? 'bg-white/15 text-white ring-1 ring-white/20'
        : 'bg-gradient-to-br from-teal-500 to-teal-700 text-white',
      className
    )}
    aria-hidden
  >
    <svg
      className={iconSizeMap[size]}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7 4v10a5 5 0 0 0 10 0V4" />
    </svg>
  </div>
);

export default BrandMark;
